export default __webpack_public_path__ + "static/media/enghien01min.0bac069c.jpg";